import React from 'react';
import TableBody from '@material-ui/core/TableBody';
import Table from '@/modules/common/components/Table';
import TableContainer from '@/modules/common/components/TableContainer';
import TableRow from './TableRow';

const map = [
    ['ID заявки', '{adv_sub}'],
    ['ID оффера', '{offer_id}'],
    ['Тип заявки', '{type_code}'],
    ['UNIX-время', '{timestamp}'],
    ['Source', '{source}'],
    ['Affiliate Sub', '{aff_sub}'],
    ['Affiliate Sub 2', '{aff_sub2}'],
    ['Affiliate Sub 3', '{aff_sub3}'],
    ['Affiliate Sub 4', '{aff_sub4}'],
    ['Adv Sub', '{adv_sub2}'],
    ['Код статуса', '{status_code}'],
    ['UNIX-время статуса', '{status_timestamp}'],
    ['Цена лида', '{partner_price}'],
];

const Component = () => {
    // noinspection JSValidateTypes
    return (
        <TableContainer>
            <Table>
                <TableBody>
                    {map.map((row, id) => (
                        <TableRow key={id} title={row[0]} value={row[1]}/>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default Component;
